import React, {memo, useState, useCallback, useContext} from 'react';
import {
    setAutomationGuidePoint,
    setAutomationPointHovered,
    setAutomationPointsSelected,
    setAutomationPointDragging} from 'actions/index.js';
import { connect } from "react-redux";
import {AutomationContext} from './context.js';
import { Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import {
    addAutomationBreakpoint,
    removeAutomationBreakpoint,
    moveAutomationBreakpoint
} from 'operations/actions.js';
import {
    getYPositionFromValue,
    getXPositionFromStep,
    getStepFromXPosition,
    getValueFromYPosition
} from './position.js';

import AutomationTooltip from './AutomationTooltip.js';

const AutomationPoint = memo(({
    height,
    width,
    xScale,
    isSelected,
    setAutomationPointHovered,
    setPointsSelected,
    isHovered,
    selectedParameter,
    point,
    sequencerEngine,
    track,
    operationManager,
    setGuidePoint,
    isDragging,
    setPointDragging,
    automation}) => {
        
        const onMouseOver = useCallback((e) => {
            setAutomationPointHovered(point);
            setGuidePoint(undefined);
        }, [, setGuidePoint]);
        
        const onMouseLeave = useCallback((e) => {
            setAutomationPointHovered(undefined);
        }, []);
        
        const onClickPoint = useCallback(() => {
            const pointDragging = sequencerEngine.state.automation.pointDragging[track.id];
            const pointHasMoved = sequencerEngine.state.automation.pointHasMoved[track.id];
            if (!pointHasMoved) {
                operationManager.dispatch(
                    removeAutomationBreakpoint(
                        automation,
                        pointDragging));

                setAutomationPointHovered(undefined);
            }

       }, [selectedParameter, automation]);
        
        if (selectedParameter === undefined) {
            return ([]);
        }
        let x = getXPositionFromStep(point.step, xScale, width);
        let y = getYPositionFromValue(
            point.value,
            height,
            selectedParameter.min,
            selectedParameter.max);
        
        let fillColor = isSelected || isHovered || isDragging ? "orange" : "black";
        let strokeColor = isSelected || isHovered || isDragging ? "orange" : "red";
        let radius = isHovered ? 5 : 3;
        return [(
              <ellipse
                onMouseDown={(e) => {
                    e.stopPropagation();
                    setPointDragging(point);
                    if (!isSelected) {
                        setPointsSelected([]);
                    }
                }}
                onMouseUp={onClickPoint}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
                cx={x}
                cy={y}
                className={isSelected ? "selected automation-point" : "automation-point"}
                rx={radius}
                ry={radius}
                fill={fillColor}
                strokeWidth={2}
                stroke={strokeColor}
              />),
                isDragging || isHovered ? <AutomationTooltip height={height} x={x} y={y} selectedParameter={selectedParameter} value={point.value}/> : []
               ];
    });

const mapDispatchToProps = (dispatch, props) => {
    return {
        setGuidePoint: (pt) => dispatch(setAutomationGuidePoint(props.track.id, pt)),
        setPointDragging: (pt) => dispatch(setAutomationPointDragging(props.track.id, pt)),
        setPointsSelected: (pts) => dispatch(setAutomationPointsSelected(props.track.id, pts)),
        setAutomationPointHovered: (pt) => dispatch(setAutomationPointHovered(props.track.id, pt)),
    };
};

export default connect(null, mapDispatchToProps)(AutomationPoint);



